<template>
  <div class="tenants-list">
    <div v-if="isOriginBackoffice">
      <div class="pool-usage-box" v-if="Object.keys(countPerPool).length > 0">
        <div>
          <div class="env-filter-box">
            <h4>Quantidade de Clientes por Banco de Dados</h4>
            <span class="env-filter-span-warning pb-1 pt-1">
              <span class="span-env-filter">Filtrar por ambiente (Produção ou Beta)</span>
              <vs-switch class="ml-1 mr-2" v-model="filterByEnvironment">
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </span>
          </div>
        </div>
        <ul>
          <li v-for="(value, key) in countPerPool" :key="key">
            <strong class="pool-usage-key">{{ key }}:</strong>
            <span class="pool-usage-value">&nbsp; {{ value }} / 1024</span>
          </li>
        </ul>
      </div>
      <div class="pool-usage-box error" v-else>
        Não há dados disponíveis sobre a quantidade de clientes por banco de dados.
      </div>
    </div>

    <vs-table
      ref="table"
      noDataText="Sem dados disponíveis"
      search
      :data="tenants"
      :sst="true"
      :max-items="itemsPerPage"
      @search="searchFilter"
      @sort="sortFilter"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center" v-if="isOriginBackoffice">
          <div v-if="canSee('add')" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-betweentext-lg font-medium text-base text-primary border border-solid border-primary" @click="addDataSideBar=true">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>

          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-betweentext-lg font-medium text-base text-primary border border-solid border-primary" @click="downloadModals.orders=true">
            <span class="ml-2 text-base text-primary">Relatório de Pedidos</span>
          </div>

          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-betweentext-lg font-medium text-base text-primary border border-solid border-primary" @click="downloadModals.instanceLogs=true">
            <span class="ml-2 text-base text-primary">Relatório de Desconexões</span>
          </div>
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bgcursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{ tenants.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tenants.length }} de {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="fqdn">Nome</vs-th>
        <vs-th sort-key="created_at">Criado Em</vs-th>
        <vs-th sort-key="deleted_at" v-if="isOriginBackoffice">Deletado em</vs-th>
        <vs-th sort-key="cnpj" v-if="isOriginBackoffice">CNPJ</vs-th>
        <vs-th sort-key="plan" v-if="isOriginBackoffice">Plano</vs-th>
        <vs-th sort-key="user_limit" v-if="isOriginBackoffice">Limite de Usuários</vs-th>
        <vs-th sort-key="ticket_limit" v-if="isOriginBackoffice">Limite de Atendimentos</vs-th>
        <vs-th v-if="canSee('instances') && isOriginBackoffice">Conexões</vs-th>
        <vs-th>Acessar</vs-th>
        <vs-th v-if="canSee('reactivate') && isOriginBackoffice">Ação</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in tenants">
            <vs-td>
              <p id="value" class="product-name font-medium truncate">{{ tr.fqdn.split(".")[0] }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ parseDateToBR(tr.created_at) }}</p>
            </vs-td>

            <vs-td v-if="isOriginBackoffice">
              <vx-tooltip
                v-if="tr.deleted_at"
                delay=".2s"
                color="dark"
                position="top"
                :text="deletionTooltipText(tr)"
              >
                <p class="product-name font-medium truncate">{{ parseDateToBR(tr.deleted_at) }}</p>
              </vx-tooltip>
              <p v-else class="product-name font-medium truncate">{{ parseDateToBR(tr.deleted_at) }}</p>
            </vs-td>

            <vs-td v-if="isOriginBackoffice">
              <p class="product-name font-medium truncate">{{ tr.cnpj }}</p>
            </vs-td>

            <vs-td v-if="isOriginBackoffice">
              <p class="product-name font-medium truncate">{{ parsePlan(tr.plan) || 'Não informado' }}</p>
            </vs-td>

            <vs-td v-if="isOriginBackoffice">
              <p class="product-name font-medium truncate">{{ tr.user_limit || 'Não informado' }}</p>
            </vs-td>

            <vs-td v-if="isOriginBackoffice">
              <p class="product-name font-medium truncate">{{ tr.ticket_limit || 'Não informado' }}</p>
            </vs-td>

            <vs-td v-if="canSee('instances') && isOriginBackoffice">
              <p>
                <vs-button :disabled="tr.deleted_at !== null" color="success" @click=openInstancesModal(tr)>Conexões</vs-button>
              </p>
            </vs-td>

            <vs-td class="actionTD">
              <div class="inline-flex gap-1">
                <vs-button :disabled="tr.deleted_at !== null || wrongBackoffice(tr)" @click=redirectToLink(tr)>
                  Acessar
                </vs-button>
                <vx-tooltip delay=".2s" color="warning" class="align-self-center" position="bottom" v-if="wrongBackoffice(tr)" text="Acessível pelo Backoffice de Beta">
                  <vs-icon color="warning" icon="info"/>
                </vx-tooltip>
              </div>
            </vs-td>

            <vs-td v-if="(canSee('reactivate') || canSee('feature-update') || isFuncionalUser) && isOriginBackoffice" class="actionTD">
              <div class="inline-flex gap-1">
                <vx-tooltip
                  delay=".2s"
                  color="gray"
                  class="ml-0"
                  position="bottom"
                  :text="tr.deleted_at ? 'Ver informações' : 'Gerenciar'"
                >
                  <vs-icon @click="goToInternalSettings(tr)" icon="settings"></vs-icon>
                </vx-tooltip>

                <vx-tooltip
                  delay=".2s"
                  color="gray"
                  position="bottom"
                  v-if="canSee('reactivate')"
                  :text="tr.deleted_at === null ? 'Desativar' : 'Reativar'"
                >
                  <vs-icon @click="confirmAction(tr)" :icon="tr.deleted_at === null ? 'delete' : 'restore'"></vs-icon>
                </vx-tooltip>

                <!--
                <vx-tooltip
                  delay=".2s"
                  color="gray"
                  class="ml-0"
                  position="bottom"
                  v-if="canSee('feature-update') && !tr.deleted_at"
                  text="Editar"
                >
                  <vs-icon @click="loadFeatures(tr)" icon="edit"></vs-icon>
                </vx-tooltip>

                <vx-tooltip
                  delay=".2s"
                  color="gray"
                  class="ml-0"
                  position="bottom"
                  v-if="!tr.deleted_at"
                  text="Relatório de Atendimentos 24h"
                >
                  <vs-icon @click="downloadModals.attendances = true; websiteId = tr.website_id" icon="attach_money"></vs-icon>
                </vx-tooltip>

                <vx-tooltip
                  delay=".2s"
                  color="gray"
                  class="ml-0"
                  position="bottom"
                  v-if="isFuncionalUser && !tr.deleted_at"
                  text="Relatório de Disparos"
                >
                  <vs-icon @click="downloadWebhooksData.tenantName = tr.fqdn.split('.')[0]; downloadModals.webhooks = true" icon="file_download"></vs-icon>
                </vx-tooltip>

                <vx-tooltip
                  delay=".2s"
                  color="gray"
                  class="ml-0"
                  position="bottom"
                  v-if="!tr.deleted_at && isOriginBackoffice"
                  text="Sincronizar Analytics"
                >
                  <vs-icon @click="downloadModals.syncAnalytics = true; tenantName = tr.fqdn.split('.')[0];" icon="autorenew"></vs-icon>
                </vx-tooltip>
                -->
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="mt-3 mr-4">
      <vs-pagination
        :total="totalPages"
        v-model="page"
        max="7"
      />
    </div>

    <OrdersReport
      :isActive="downloadModals.orders"
      @input="downloadModals.orders = $event"
      @isActiveFalse="downloadModals.orders=false"
    />

    <AttendancesReport
      :isActive="downloadModals.attendances"
      :websiteId="websiteId"
      @input="downloadModals.attendances = $event"
      @isActiveFalse="downloadModals.attendances=false"
    />

    <SyncAnalytics
      :tenantName="tenantName"
      :isActive="downloadModals.syncAnalytics"
      @input="downloadModals.syncAnalytics = $event"
      @isActiveFalse="downloadModals.syncAnalytics=false"
    />

    <InstanceLogsReport
      :isActive="downloadModals.instanceLogs"
      @input="downloadModals.instanceLogs = $event"
      @isActiveFalse="downloadModals.instanceLogs=false"
    />

    <TenantActionModal
      :active="confirmActionIsActive"
      :action-label="action"
      :loading="tenantActionLoading"
      :requires-reason="true"
      @input="confirmActionIsActive = $event"
      @confirm="handleTenantAction"
    />

    <vs-popup title="Atenção" :active.sync="databaseNotFoundIsActive" button-hidden>
      <p class="mt-0 pt-0 font-medium">O banco de dados deste cliente não existe mais. Não é possível reativar. Por favor, crie um novo tenant/instância.</p>
    </vs-popup>

    <WebhooksReport
      :isActive="downloadModals.webhooks"
      :tenantName="downloadWebhooksData.tenantName"
      @close="downloadModals.webhooks = false"
      @isActiveFalse="downloadModals.webhooks=false"
    />

    <tenant-view-sidebar-add
      :defaultPlans="defaultPlans"
      :isSidebarActive="addDataSideBar"
      @closeSidebar="toggleAddDataSidebar"
    />

    <InstancesModal
      :isActive="instancesModalIsActive"
      :tenantName="tenantName"
      :token="token"
      @isActiveFalse="instancesModalIsActive=false"
      @createInstance="openInstanceCreationModal"
    />

    <CreateInstanceModal 
      :isActive="createInstanceModalIsActive"
      :tenantName="tenantName"
      @isActiveFalse="createInstanceModalIsActive=false"
      @successfullyCreated="instanceSuccessfullyCreated"
    />

    <UpdateTenantModal
      :tenant="tenant"
      :features="activeFeatures"
      :enabledPlan="enabledPlan"
      :defaultPlans="defaultPlans"
      :isActive="updateTenantModalIsActive"
      @setState="(newVal, features) => setState(newVal, features, 'updateTenantModalIsActive')"
      @setPlan="updatePlan"
    />
  </div>
</template>

<script>
import { availablePlans, hasPermissionBackOffice, getIp, formatDate } from './../../utils/index';
import TenantViewSidebarAdd from './TenantViewSidebarAdd.vue';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import CreateInstanceModal from './CreateInstance.vue';
import UpdateTenantModal from './UpdateTenant.vue';
import InstancesModal from './InstancesList.vue';
import TenantActionModal from './TenantActionModal.vue';
import AttendancesReport from "../configs/AttendancesReport.vue";
import WebhooksReport from "../configs/WebhooksReport.vue";
import OrdersReport from "../configs/OrdersReport.vue";
import InstanceLogsReport from "../configs/InstanceLogsReport.vue";
import SyncAnalytics from "../configs/SyncAnalytics.vue";
import flatPickr from 'vue-flatpickr-component';
import audit from '@/http/requests/audit';
import debounce from 'lodash/debounce';
import 'flatpickr/dist/flatpickr.css';
import { mapGetters } from 'vuex';
import jwt from "jsonwebtoken";

export default {
  name: 'users-list',
  components: {
    TenantViewSidebarAdd,
    InstancesModal,
    CreateInstanceModal,
    UpdateTenantModal,
    TenantActionModal,
    AttendancesReport,
    WebhooksReport,
    OrdersReport,
    InstanceLogsReport,
    SyncAnalytics,
    flatPickr
  },
  data() {
    return {
      databaseNotFoundIsActive: false,
      alterPopupActivated: false,
      userInfos: {},
      sidebarActive: false,
      addDataSideBar: false,
      instancesModalIsActive: false,
      tenantName: '',
      enabledPlan: null,
      tenant: null,
      createInstanceModalIsActive: false,
      updateTenantModalIsActive: false,
      confirmActionIsActive: false,
      tenantActionLoading: false,
      action: 'Desativar',
      flatpickr: {
        enableTime: false,
        noCalendar: false,
        dateFormat: "d/m/Y",
        locale: Portuguese
      },
      downloadModals: {
        orders: false,
        webhooks: false,
        attendances: false,
        instanceLogs: false,
        syncAnalytics: false,
      },
      toUpdate: {},
      activeFeatures: [],
      isFuncionalUser: false,
      downloadWebhooksData: {
        sms: false,
        email: false,
        startAt: '',
        finishAt: '',
        tenantName: '',
      },
      configDateTimePickerFinishAt: null,
      configDateTimePickerStartAt: {
        enableTime: true,
        noCalendar: false,
        dateFormat: "d/m/Y H:i:s",
        locale: Portuguese,
      },
      startAt: '',
      finishAt: '',
      ordersData: {},
      instanceLogsData: {},
      search: '',
      page: 1,
      itemsPerPage: 4,
      isMounted: false,
      orderBy: {
        name: 'id',
        type: 'DESC'
      },
      debouncedSearchFilter: null,
      attendancesData: [],
      costs: false,
      websiteId: null,
      filterByEnvironment: false,
      defaultPlans: availablePlans()
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'name',
      'email',
      'users',
      'hasLogged',
    ]),
    totalPages() {
      return this.$store.state.tenants && this.$store.state.tenants.paginatedTenants
        ? this.$store.state.tenants.paginatedTenants.total_pages : 0;
    },
    queriedItems() {
      return this.$store.state.tenants && this.$store.state.tenants.paginatedTenants
        ? this.$store.state.tenants.paginatedTenants.total_items : 0;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    tenants() {
      return this.$store.state.tenants && this.$store.state.tenants.paginatedTenants
        ? this.$store.state.tenants.paginatedTenants.items : [];
    },
    isOriginBackoffice(){
      return process.env.VUE_APP_ORIGIN_BACKOFFICE && process.env.VUE_APP_ORIGIN_BACKOFFICE === 'true'
    },
    disableDownload(){
      return !this.startAt || !this.finishAt || this.startAt === '' || this.finishAt === ''
    },
    countPerPool() {
      return this.$store.state.tenants && this.$store.state.tenants.countPerPool ? this.$store.state.tenants.countPerPool : {};
    },
  },
  watch: {
    'downloadModals.orders'(value) {
      if (!value) {
        this.ordersData = {};
        this.startAt = '';
        this.finishAt = '';
      }
    },
    'downloadModals.attendances'(value) {
      if (!value) {
        this.startAt = '';
        this.finishAt = '';
        this.costs = false;
        this.websiteId = null;
        this.attendancesData = [];
      }
    },
    'downloadModals.instanceLogs'(value) {
      if (!value) {
        this.instanceLogsData = {};
        this.startAt = '';
        this.finishAt = '';
      }
    },
    'downloadModals.syncAnalytics'(newValue) {
      if (!newValue) {
        this.startAt = '';
        this.finishAt = '';
        this.tenantName = '';
        this.forceUpdateAnalytics = false;
      }
    },
    'downloadWebhooksData.startAt'(newValue) {
      this.configDateTimePickerFinishAt.minDate = newValue;
      this.$forceUpdate();
    },
    'downloadModals.webhooks'(newValue) {
      if (!newValue) {
        this.downloadWebhooksData = {
          sms: false,
          email: false,
          startAt: '',
          finishAt: '',
          tenantName: '',
        };
      }
    },
    'page'() {
      this.fetch();
    },
    'itemsPerPage'() {
      this.page = 1;
      this.fetch();
    },
    filterByEnvironment() {
      this.fetchCountPerPool();
    },
  },
  methods: {
    wrongBackoffice(tenantData) {
      return tenantData && tenantData.is_beta && !window.location.host.includes('beta');
    },
    closePopupDashs(){
      this.addDataSideBar = false
      this.instancesModalIsActive = false;
    },
    verify(){
      const permissions = localStorage.getItem('permissions');
      const twoFactor = localStorage.getItem('twoFactor')
      if(!permissions && !twoFactor){
          this.$router.push('/user-settings')
      }else if(!permissions && twoFactor){
          this.$router.push('/two-factor')
      }
    },
    tenantUrl(tr) {
      return process.env.VUE_APP_PEDBOT_ADMIN_URL + '/' + tr.fqdn.split(".")[0];
    },
    async redirectToLink(tr) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (!userInfo || (userInfo && !userInfo.name)) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Não foi possível coletar as informações do usuário.',
        });
      }

      let userName = null;
      try {
        userName = btoa(new TextEncoder().encode(userInfo.name).reduce((data, byte) => data + String.fromCharCode(byte), ''));
      } catch (error) {
        console.error(error);
        return this.$vs.notify({
          color: 'danger',
          title: 'Não foi possível encodificar as informações do usuário.',
        });
      }

      let ip = '0.0.0.0';
      try {
        ip = await getIp();
        ip = btoa(new TextEncoder().encode(ip).reduce((data, byte) => data + String.fromCharCode(byte), ''));
      } catch (error) {
        console.error(error);
      }

      const tenant = tr.fqdn.split(".")[0];
      const tokenPayload = { tenant: tenant, exp: Math.floor(Date.now() / 1000) + (3 * 60) };

      const baseUrl = `${process.env.VUE_APP_PEDBOT_ADMIN_URL}/${tenant}/login`;
      const access_key = jwt.sign(tokenPayload, process.env.VUE_APP_LOGIN_TOKEN);
      const access_token = process.env.VUE_APP_INTEGRATION_TOKEN;

      const params = new URLSearchParams();
      params.append('access_token', access_token);
      params.append('access_key', access_key);
      params.append('user_name', userName);
      params.append('ip', ip);

      const url = `${baseUrl}?${params.toString()}`;
      window.open(url, '_blank');
    },
    async accessesRegister(tenant) {
      await audit.registerAccess(tenant, localStorage.getItem("accessToken"))
      .catch( error => {
        console.log(error)
      })
    }, 
    async fetch() {
      await this.$store.dispatch('fetchPaginatedTenants', {
        sortName: this.orderBy.name,
        sortType: this.orderBy.type,
        limit: this.itemsPerPage,
        search: this.search,
        page: this.page,
        token: this.token,
        filterUsers: true,
      });
    },
    searchFilter(searchQuery) {
      this.search = searchQuery ? searchQuery.trim() : searchQuery;
      this.page = 1;
      this.debouncedSearchFilter();
    },
    handleSearch() {
      this.fetch();
    },
    sortFilter(sortName) {
      if (sortName !== null) {
        if (sortName !== this.orderBy.name) {
          this.orderBy.name = sortName;
          this.orderBy.type = 'ASC';
        } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
          this.orderBy.type = 'DESC';
        } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
          this.orderBy.name = 'fqdn';
          this.orderBy.type = 'ASC';
        }
        this.fetch();
      }
    },
    toggleAddDataSidebar(val = false) {
      this.addDataSideBar = val;
      if (!val) {
        this.fetch();
        this.fetchCountPerPool();
      }
    },
    openInstancesModal(tr) {
      this.tenantName = tr.fqdn.split('.')[0];
      this.instancesModalIsActive = true;
    },
    canSee(word) {
      return hasPermissionBackOffice(`${this.$route.name}-${word}`);
    },
    openInstanceCreationModal(tenantName) {
      this.tenantName = tenantName;
      this.instancesModalIsActive = false;
      this.createInstanceModalIsActive = true;
    },
    instanceSuccessfullyCreated() {
      this.createInstanceModalIsActive = false;
      this.instancesModalIsActive = true;
    },
    parseDateToBR(value) {
      if (!value) return '-';
      try {
        const date    = new Date(value);
        const day     = String(date.getDate()).padStart(2, '0');
        const month   = String(date.getMonth() + 1).padStart(2, '0');
        const year    = String(date.getFullYear()).slice(-2);
        const hours   = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} às ${hours}:${minutes}`;
      } catch (exception) {
        return value;
      }
    },
    parseDateToISO(dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year]   = datePart.split('/');
      return `${year}-${month}-${day} ${timePart}`;
    },
    getTenantPoolName(data) {
      if (data.managed_by_database_connection) return data.managed_by_database_connection;
      if (data.website && data.website.managed_by_database_connection) return data.website.managed_by_database_connection;
      return null;
    },
    getExistingPoolNames() {
      const cp = this.countPerPool;
      if (!cp || typeof cp !== 'object') return [];
      if (cp.data && typeof cp.data === 'object' && !Array.isArray(cp.data)) return Object.keys(cp.data);
      if (cp.pools && typeof cp.pools === 'object' && !Array.isArray(cp.pools)) return Object.keys(cp.pools);
      return Object.keys(cp);
    },
    tenantDeletedBy(tenant) {
      if (!tenant) return 'Não informado';
      if (tenant.deleted_by_user_name) return tenant.deleted_by_user_name;
      if (tenant.deleted_by_user_id) return `ID ${tenant.deleted_by_user_id}`;
      return 'Não informado';
    },
    tenantDeletedReason(tenant) {
      return tenant && tenant.deleted_reason ? tenant.deleted_reason : 'Não informado';
    },
    deletionTooltipText(tenant) {
      const deletedAt = tenant && (tenant.deleted_action_at || tenant.deleted_at)
        ? formatDate(tenant.deleted_action_at || tenant.deleted_at).full
        : 'Não informado';
      return `Excluído por: ${this.tenantDeletedBy(tenant)} | Motivo: ${this.tenantDeletedReason(tenant)} | Data/hora: ${deletedAt}`;
    },
    confirmAction(data) {
      this.action = data.deleted_at ? 'Restaurar' : 'Desativar';
      this.toUpdate = data;

      if (!data.deleted_at) {
        this.confirmActionIsActive = true;
        return;
      }

      const poolName = this.getTenantPoolName(data);

      this.$store.dispatch('countPerPool', { filterByEnvironment: true, token: this.token }).then(() => {
        if (!poolName) {
          this.databaseNotFoundIsActive = true;
          return;
        }
        const existingPools = this.getExistingPoolNames();
        const poolNameNormalized = poolName ? String(poolName).replace(/^tenancy\./, '') : '';
        const poolExists = existingPools.indexOf(poolName) >= 0 || existingPools.indexOf(poolNameNormalized) >= 0;
        if (poolExists) {
          this.confirmActionIsActive = true;
        } else {
          this.databaseNotFoundIsActive = true;
        }
      }).catch((exception) => {
        console.error('Erro no countPerPool: ', exception);
        this.$vs.notify({ color: 'danger', title: 'Erro!', text: 'Não foi possível verificar os bancos de dados. Tente novamente.' });
      });
    },
    handleTenantAction(reason) {
      this.updateTenant(this.toUpdate, reason);
    },
    async updateTenant(tenant, reason = null) {
      const isRestore = !!tenant.deleted_at;
      const action = isRestore ? 'restoreTenant' : 'deleteTenant';

      if (!reason) {
        this.$vs.notify({
          color: 'warning',
          title: 'Motivo obrigatório',
          text: 'Informe o motivo antes de continuar.'
        });
        return;
      }

      this.$vs.loading();
      this.tenantActionLoading = true;

      try {
        await this.$store.dispatch(action, { id: tenant.id, reason, token: this.token });
        await this.fetch();
        await this.fetchCountPerPool();
        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: `Tenant ${isRestore ? 'Reativado' : 'Desativado'} com sucesso!`
        });
      } catch (exception) {
        console.error(exception);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao realizar a ação! Entre em contato com o time técnico.'
        });
      } finally {
        this.confirmActionIsActive = false;
        this.tenantActionLoading = false;
        this.toUpdate = {};
        this.$vs.loading.close();
      }
    },
    parsePlan(plan){
      if (!plan) { return plan; }
      plan = plan.toUpperCase();
      return ( this.defaultPlans.filter(item => item.value === plan)[0].text || null );
    },
    updatePlan({plan, user, ticket}) {
      this.$vs.loading();

      if ( !plan ) {
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Informe um valor válido para o Plano.'
        });
        return;
      }

      plan = plan.toUpperCase();
      this.$store.dispatch('updateTenantPlan', { token: this.token, id: this.tenant.id, plan: plan, user: user, ticket: ticket}).then(() => {
        this.fetch();
        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: `Plano do Tenant atualizado com sucesso.`
        });
      }).catch(exception => {
        console.error(exception);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao realizar a ação! Entre em contato com o time técnico.'
        });
      });

      this.$vs.loading.close();
    },
    parseDate(dateString, toBrazilian = false) {
      if (!dateString) return dateString;
      const parts = dateString.split(toBrazilian ? '-' : '/');
      return toBrazilian ? `${parts[2]}/${parts[1]}/${parts[0]}` : `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    syncAnalytics() {
      this.$vs.loading();
      this.$store.dispatch('syncAnalytics', {
        toDate: this.parseDate(this.finishAt),
        fromDate: this.parseDate(this.startAt),
        forceUpdate: this.forceUpdateAnalytics,
        tenantName: this.tenantName,
        token: this.token
      }).then(response => {
        this.downloadModals.syncAnalytics = false;
        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: response.data
        });
      }).catch(exception => {
        console.error(exception);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao realizar a ação! Entre em contato com o time técnico.'
        });
      });
      this.$vs.loading.close();
    },
    setState(newVal, features, name) {
      this[name] = newVal;
      if (features && Object.keys(features).length) {
        this.$store.dispatch('updateFeatures', {features: features, tenantName: this.tenantName, token: this.token})
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: `Features ativadas com sucesso!`
          });
        })
        .catch(exception => {
          this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: 'Ocorreu um erro ao realizar a ação! Entre em contato com o time técnico.'
          });
          console.error(exception)
        });
      }
    },
    loadFeatures(tr) {
      this.tenantName = tr.fqdn.split('.')[0];
      this.$store.dispatch('getFeatures', {
        token: this.token,
        tenantName: this.tenantName
      })
      .then(response   => {
        const features = (response && response.data ? response.data : []);
        this.tenant = tr;
        this.enabledPlan = tr.plan;
        this.activeFeatures = features.filter(item => item.name !== 'websocket');
        this.updateTenantModalIsActive = true;
      })
      .catch(exception => console.error(exception));
    },
    missingParameters(data) {
      return (
        !data['startAt']  || data['startAt']  === '' ||
        !data['finishAt'] || data['finishAt'] === '' ||
        (!data['sms'] && !data['email'])
      )
    },
    downloadWebhooks(data) {
      if (this.missingParameters(data)) {
        return this.$vs.notify({
          color: 'warning',
          title: 'Preencha todos os campos.'
        });
      }

      this.$store.dispatch('generateCampaignStatusWebhook', {
        token: this.token,
        tenantName: data.tenantName,
        startAt: this.parseDateToISO(data.startAt),
        finishAt: this.parseDateToISO(data.finishAt),
        type: {
          1: data.sms,
          3: data.email
        }
      })
      .then(() => {
        this.$vs.notify({
          color: 'success',
          title: 'O upload dos dados dos disparos será feito no Bucket da Funcional em breve!',
          time: 15000
        });
        this.downloadModals.webhooks = false;
      })
      .catch(exception => console.error(exception));
    },
    fetchCountPerPool() {
      this.$store.dispatch('countPerPool', { filterByEnvironment: this.filterByEnvironment, token: this.token }).catch(exception => console.error('Erro no countPerPool: ', exception));
    },
    goToInternalSettings(tr) {
      const tenantName = tr.fqdn.split('.')[0];
      localStorage.setItem('tenantFqdn', tr.fqdn);
      this.$router.push(`/info/${tenantName}`);
    },
  },
  beforeCreated() {
    this.$store.commit('setTenants', {tenants: []});
  },
  created() {
    this.debouncedSearchFilter = debounce(this.handleSearch, 500);
    this.configDateTimePickerFinishAt = {
      ...this.configDateTimePickerStartAt,
      minDate: this.downloadWebhooksData.startAt,
    };
  },
  mounted() {
    this.verify(); 
    this.fetch();
    this.isMounted = true;
    this.fetchCountPerPool();
    this.$store.dispatch('isFuncionalUser', this.token).then(response => this.isFuncionalUser = !!response.data);
  },
  beforeRouteLeave(to, from, next) {
    this.closePopupDashs()
    this.$events.fire('closePopUpCreate');
    this.$events.fire('closeSyncProducts');
    this.$events.fire('closePopUpUpdate');
    this.$events.fire('closePopUpSyncMessages');
    setTimeout( ()=> {
      next();
    }, 10);
  }
}
</script>

<style lang="scss">
.align-self-center{
  align-self: center !important;
}

.tenants-list {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;
          text-align: center;
          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
        td.td.vs-table--td.actionTD > span {
          display: flex;
          justify-content: center;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
          justify-content: center !important;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.ulOrderSheet {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin: 10px 0;
    padding: 10px;
    transition: transform 0.2s, box-shadow 0.2s;
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
  }
  span {
    font-weight: bold;
    color: #555;
  }
  a {
    color: #007bff;
    font-weight: bold;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      color: #0056b3;
    }
  }
}
.pool-usage-box {
  min-width: 220px;
  padding: 15px 20px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  margin-left: 20px;
  margin-right: 16px;
  margin-bottom: 1rem;
  h4 {
    font-weight: 600;
    font-size: 15px;
    color: #333;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      padding: 6px 0;
      border-bottom: 1px solid #f3f3f3;
      .pool-usage-key {
        color: rgba(0, 80, 252, 0.801);
      }
      .pool-usage-value {
        font-weight: 500;
      }
      strong {
        color: #555;
      }
    }
  }
  &.error {
    border-color: #dca469;
    background: #faf0e0;
    color: #dca469;
    text-align: center;
    font-weight: 600;
  }
  .env-filter-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f3f3f3;
    padding: 8px 0 14px 0;
    margin-bottom: 10px;
    span.env-filter-span-warning {
      margin-left: 10px;
      padding-top: 2px;
      padding-bottom: 2px;
      display: flex;
      border-width: 1px !important;
      background: #e0ebfe98;
      border: 1px solid #2c77faad;
      border-radius: 6px;
      span.span-env-filter {
        margin-top: 2px;
        margin-left: 6px;
        margin-right: 6px;
        font-size: 12px;
        color: #2c79fa;
        font-weight: 500;
      }
    }
  }
}
</style>
